import { instanceMainService, instancePoapService } from './api.instance'

const initMainClient = (middleware: any) => {
  middleware(instanceMainService)
}

const initPoapClient = (middleware: any) => {
  middleware(instancePoapService)
}

export { initMainClient, initPoapClient }
